import { createComponent } from '@carvana/merch-components';
import AnchorButton from '@/common/AnchorButton';
import BackArrowIcon from '~/icons/BackArrow';

export const CommonMaxWidthDiv = createComponent('div', {
  className: 'max-w-[912px]'
});

export const PickupAndDeliveryWrapper = createComponent(CommonMaxWidthDiv, {
  className: 'm-auto divide-y divide-grey-2 rounded-[6px] border border-grey-2'
});

export const TransitCharge = createComponent('div', {
  className: 'mt-4 text-center text-grey-5 tl-body-s m:tl-body-m'
});

export const Wrapper = createComponent('div', {
  className: 'mt-12 flex w-full flex-col content-center border border-grey-2'
});

export const HeaderWrapper = createComponent('div', {
  className:
    'mx-16 grid grid-cols-[32px,1fr,auto] grid-rows-[32px] items-center gap-x-12 py-12 tl-header-s m:mx-32 m:grid-cols-[56px,1fr,auto] m:grid-rows-[48px] m:gap-x-32'
});

export const Text = createComponent('p', {
  className: 'text-blue-7'
});

export const LinkWrapper = createComponent(AnchorButton, {
  className: 'flex flex-row items-center justify-end gap-4 uppercase'
});

export const ContentWrapper = createComponent('div', {
  className:
    'mx-24 flex flex-col gap-8 border-t border-grey-2 py-24 text-grey-5'
});

export const ForwardArrow = createComponent(BackArrowIcon, {
  className: 'rotate-180 stroke-blue-6'
});
